import { Link } from "@tanstack/react-router";
import { BadgeCheck } from "lucide-react";
import type { StoreListing } from "@/api/store.api";
import { primaryTag, tagLabel } from "./labels";
import { ListingIcon } from "./listing-icon";

/** Row card, like the phone's: icon, name, tagline, publisher and primary tag. */
export function ListingCard({ listing }: { listing: StoreListing }) {
  const tag = primaryTag(listing);
  return (
    <Link
      to="/$packageName"
      params={{ packageName: listing.packageName }}
      className="group flex items-center gap-4 rounded-[18px] border border-[#e4e6e2] bg-white p-4 shadow-[0_1px_2px_rgba(20,21,27,0.05)] transition-colors hover:border-[#c9cdc6] hover:bg-[#fbfcfa] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
    >
      <ListingIcon listing={listing} size={56} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="truncate text-[15px] font-semibold text-[#14151b]">{listing.name}</span>
          {listing.author.verified ? <BadgeCheck className="size-4 shrink-0 text-[#087d50]" aria-label="Verified publisher" /> : null}
        </div>
        <p className="mt-0.5 line-clamp-2 text-[13px] leading-[18px] text-[#5d6068]">{listing.tagline || listing.description}</p>
        <p className="mt-1 truncate text-[11px] text-[#8a8d95]">
          {listing.author.name}
          {tag ? <> · {tagLabel(tag)}</> : null}
        </p>
      </div>
    </Link>
  );
}
